




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PageHeaderOverlay extends Vue {
  @Prop({ default: require('@/assets/bhang_slider_2.jpg') })
  backgroundImg!: string;

  @Prop() title!: string;

  @Prop() description!: string;
}
